import { Components } from "@thisgorilla/primate-ds";
import { useTheme } from "styled-components";
import { FlexRowSpaced } from "../../../../../Common/Styles";
import PeopleYouMightKnowProps from "./PeopleYouMightKnow";

export const TitleAndButton = ({
  onIconButtonClick,
}: PeopleYouMightKnowProps.TitleAndButtonProps) => {
  const { typography, Color } = useTheme();

  return (
    <FlexRowSpaced>
      <Components.Text
        style={{ tokenStyle: typography.Heading.S }}
        text="People you might know"
        color={Color.text["text-emphasize-brand-bolder"].value}
      />
      <Components.IconButton
        disabled={false}
        iconType="ArrowRight"
        kind="Secondary"
        size="XS"
        onClick={onIconButtonClick}
      />
    </FlexRowSpaced>
  );
};
